import { render } from "./AllxImplantDentureCare.vue?vue&type=template&id=c0ddb3dc"
import script from "./AllxImplantDentureCare.vue?vue&type=script&lang=js"
export * from "./AllxImplantDentureCare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__